import SectionLabel from "@/components/SectionLabel";
import usePageMeta from "@/hooks/usePageMeta";

export default function Privacy() {
  usePageMeta({
    title: "Privacy, LevelLeven",
    description:
      "Zo gaat LevelLeven om met persoonsgegevens van deelnemers, gemeenten en bezoekers.",
  });

  return (
    <div>
      <section className="py-16 sm:py-24">
        <div className="max-w-[900px] mx-auto px-6 sm:px-10 lg:px-16">
          <SectionLabel>Privacy</SectionLabel>
          <h1 className="font-heading text-5xl sm:text-6xl leading-[1.05] tracking-tight text-[#1D2A22] font-light">
            Zorgvuldig met{" "}
            <span className="italic text-[#E06B3F]">wat vertrouwelijk is</span>.
          </h1>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-[900px] mx-auto px-6 sm:px-10 lg:px-16 space-y-10 text-[#4A5D4E] leading-relaxed font-light text-lg">
          <div>
            <h2 className="font-heading text-2xl text-[#1D2A22] mb-3">
              1. Wat wij verwerken
            </h2>
            <p>
              Voor deelnemers verwerken wij alleen de gegevens die nodig zijn
              voor het traject: naam, contactgegevens, gemeente van herkomst,
              en gedurende het programma de resultaten van de nulmeting en
              voortgangsrapportage. Rapportage aan de gemeente vindt geanonimiseerd
              plaats waar mogelijk, en altijd met instemming van de deelnemer.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl text-[#1D2A22] mb-3">
              2. Grondslag
            </h2>
            <p>
              De verwerking gebeurt op basis van uitvoering van de overeenkomst
              met de gemeente en, waar nodig, uitdrukkelijke toestemming van de
              deelnemer. Er worden geen gegevens gedeeld met derden buiten de
              in de overeenkomst benoemde partners.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl text-[#1D2A22] mb-3">
              3. Bewaartermijn
            </h2>
            <p>
              Gegevens worden bewaard zolang dat noodzakelijk is voor de
              uitvoering van het traject en de wettelijke bewaarplicht, daarna
              worden ze verwijderd of geanonimiseerd.
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl text-[#1D2A22] mb-3">
              4. Rechten
            </h2>
            <p>
              Deelnemers hebben op elk moment recht op inzage, correctie en
              verwijdering van hun gegevens. Verzoeken kunnen worden ingediend
              via{" "}
              <a href="mailto:info@levelleven.nl" className="text-[#E06B3F] link-underline">
                info@levelleven.nl
              </a>
              .
            </p>
          </div>

          <div>
            <h2 className="font-heading text-2xl text-[#1D2A22] mb-3">
              5. Website
            </h2>
            <p>
              Deze website plaatst geen tracking-cookies en gebruikt geen
              externe analytics. De contactformulieren, ROI-calculator en
              zelfscan werken volledig lokaal in je browser, er wordt niets
              opgeslagen tenzij je zelf op verzenden klikt.
            </p>
          </div>

          <p className="text-sm text-[#7A8276] italic pt-6 border-t border-[#E5E1D8]">
            Deze pagina is een startversie en wordt in overleg met de gemeente
            en juridisch advies verder ingevuld. Voor formele privacyvragen kun
            je altijd contact opnemen via info@levelleven.nl.
          </p>
        </div>
      </section>
    </div>
  );
}
